export const SET_FREQUENCY_SETTINGS_IDS = "SET_FREQUENCY_SETTINGS_IDS";
export const FETCH_CONFIGURED_LIMITS = "FETCH_CONFIGURED_LIMITS";
export const RESET_CONFIGURED_LIMITS = "RESET_CONFIGURED_LIMITS";
export const RESET_FREQUENCY_SETTINGS_IDS = "RESET_FREQUENCY_SETTINGS_IDS";
export const SHOW_DELETE_LIMIT_DIALOG = "SHOW_DELETE_LIMIT_DIALOG";
export const HIDE_DELETE_LIMIT_DIALOG = "HIDE_DELETE_LIMIT_DIALOG";
export const SHOW_UPDATE_LIMIT_DIALOG = "SHOW_UPDATE_LIMIT_DIALOG";
export const HIDE_UPDATE_LIMIT_DIALOG = "HIDE_UPDATE_LIMIT_DIALOG";
